import _ from 'lodash';
import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React, { createRef } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { Loader } from '../../../components/Loader';
import { selectWorks } from '../../Api/selectors';
import { REQUEST_COMPANY_PROPERTY_UPDATE } from '../../Companies/constants';
import styles from './boardMobile.module.css';
import { Carousel } from 'react-bootstrap';
import { KanbanBoardMobileCarouselItem } from './boardMobileCarouselItem';

const Container = styled.div``;
/* eslint-disable react/prefer-stateless-function */
class KanbanBoardMobileComp extends BaseComponent {
  constructor(props) {
    super(props, {});
  }

  componentDidMount() {}

  get board() {
    return this.props.board;
  }

  render() {
    if (!this.board) return null;
    if (this.props.work) return <Loader small />;

    return (
      <div className={styles.wrapper}>
        <div className={styles.container}>
          <Carousel controls={false} interval={null} className={styles.carousel}>
            {_(this.board.columns)
              .sortBy(column => column.KanbanBoardHasKanBoardColumn.sort_order)
              .map(column => {
                return (
                  <Carousel.Item key={column.id}>
                    <KanbanBoardMobileCarouselItem
                      board_id={this.board.id}
                      column={column}
                      onChange={this.props.onChange}
                      filter={this.props.filter}
                      hideOnEmpty={this.props.hideEmptyColumns}
                      cellsLength={length => this.getCells(length)}
                    />
                  </Carousel.Item>
                );
              })
              .value()}
          </Carousel>
        </div>
      </div>
    );
  }
}

KanbanBoardMobileComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    work: selectWorks([REQUEST_COMPANY_PROPERTY_UPDATE]),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const KanbanBoardMobile = compose(withConnect, withRouter)(KanbanBoardMobileComp);
